import { render, staticRenderFns } from "./InspectionCreateCardInspector.vue?vue&type=template&id=48fd9104&"
import script from "./InspectionCreateCardInspector.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardInspector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports